module.exports = __webpack_public_path__ + "static/media/macbook.9f802643.png";